import type { I18n, Locale } from 'vue-i18n';
import { createI18n } from 'vue-i18n';
import { DEFAULT_LANGUAGE } from '@/utils/constants';
import zhCN from '@/locales/zh-CN.yaml';
import enUS from '@/locales/en-US.yaml';

let i18n: I18n<NonNullable<unknown>, NonNullable<unknown>, NonNullable<unknown>, Locale, false>;

export const getInstanceAndSetLanguage = (language = DEFAULT_LANGUAGE) => {
  if (!i18n) {
    i18n = createI18n({
      legacy: false,
      locale: language,
      fallbackLocale: {
        'en-US': [DEFAULT_LANGUAGE],
      },
      messages: {
        'zh-CN': zhCN,
        'en-US': enUS,
      },
    })
  }
  else {
    i18n.global.locale.value = language;
  }

  return i18n;
}

export const getInstance = () => {
  return i18n;
}
